export default "__VITE_ASSET__BdZBTjbP__"